<div
  class="with-padding-large dialog-container confirmation-container"
  *ngIf="alert"
  [ngClass]="alert.type"
  fxLayout="column"
>
  <mat-dialog-actions
    fxLayoutAlign="center center"
    class="dialog-header"
    fxLayoutGap="8px"
  >
    <ng-container [ngSwitch]="alert.type">
      <ng-container *ngSwitchCase="AlertTypes.Error">
        <mat-icon>warning</mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="AlertTypes.Success">
        <mat-icon>check_circle</mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="AlertTypes.Info">
        <mat-icon>info</mat-icon>
      </ng-container>
    </ng-container>

    <mat-label mat-dialog-title *ngIf="alert.defaultLables"
      >{{
        (alert.title | translate) != alert.title
          ? (alert.title | translate)
          : alert.defaultLables.title
      }}
    </mat-label>

    <mat-label mat-dialog-title *ngIf="!alert.defaultLables"
      >{{ alert.title | translate }}
    </mat-label>
  </mat-dialog-actions>
  <!-- <span
    class="mat-body-1 with-horizontal-padding muted-text text-center"
    *ngIf="alert.subTitle"
  >
    {{ alert.subTitle | translate }}
  </span> -->
  <mat-dialog-content
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center"
    class="mat-body-2 text-center"
  >
    <span
      *ngIf="alert.type === AlertTypes.Error && alert.defaultLables"
      style="color: #ff4d4f"
    >
      {{
        ('ERR.' + alert.message | translate) != 'ERR.' + alert.message
          ? ('ERR.' + alert.message | translate)
          : alert.defaultLables.message
      }}
    </span>
    <span
      *ngIf="alert.type === AlertTypes.Error && !alert.defaultLables"
      style="color: #ff4d4f"
    >
      {{ 'ERR.' + alert.message | translate }}
    </span>
    <span *ngIf="alert.type !== AlertTypes.Error" style="color: #1b738b">
      {{ alert.message | translate }}
    </span>
  </mat-dialog-content>
  <div class="actions-container" fxLayout fxLayoutAlign="center center">
    <button
      mat-stroked-button
      color="primary"
      [mat-dialog-close]="true"
      *ngIf="alert.defaultLables"
    >
      {{
        (alert.okText | translate) != alert.okText
          ? (alert.okText | translate)
          : alert.defaultLables.okText
      }}
    </button>

    <button
      mat-stroked-button
      color="primary"
      [mat-dialog-close]="true"
      *ngIf="!alert.defaultLables"
    >
      {{ alert.okText | translate }}
    </button>
  </div>
</div>
